/**
 * Tailwind classes for shimmer loading animation.
 * Uses a gradient that animates horizontally to create a shimmer effect.
 */
export const SHIMMER_CLASSES =
    'bg-gradient-to-r from-fill-x40 via-fill-x30 to-fill-x40 dark:from-fill-x50 dark:via-fill-x40 dark:to-fill-x50 bg-[length:200%_auto] animate-skeleton-shimmer';
